// Importing necessary libraries and components
import React, { useState } from "react";
import axios from "axios"; // Library for making HTTP requests
import "./Contact.css"; // Importing the CSS file for styling
import { useTranslation } from "react-i18next"; // Library for internationalization

// Functional component Contact
function Contact() {
  // Destructuring translation functions from useTranslation hook
  const { t } = useTranslation("global");

  // Setting initial state for form data and messages
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    category: "",
  });
  const [successMessage, setSuccessMessage] = useState(""); // State for success message
  const [errorMessage, setErrorMessage] = useState(""); // State for error message

  // Handler for form input changes
  const handleChange = (e) => {
    const { name, value } = e.target; // Destructuring name and value from the event target
    setFormData((prevFormData) => ({
      ...prevFormData, // Copying previous form data
      [name]: value, // Updating the specific form field
    }));
  };

  // Handler for form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Preventing the default form submission behavior
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/contact`, formData); // Sending form data to the server
      setSuccessMessage("Your message has been sent successfully!"); // Setting success message
      setErrorMessage(""); // Clearing any previous error message
      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
        category: "",
      }); // Resetting form fields
    } catch (error) {
      setErrorMessage("Error sending message. Please try again."); // Setting error message
      setSuccessMessage(""); // Clearing any previous success message
    }
  };

  return (
    <div className="contact">
      <div className="contact-card">
        <div className="cnt-title">{t("Contact Us")}</div> {/* Title */}
        <div className="cnt-form">
          <div className="cnt-left">
            {/* Name Input */}
            <div className="cnt-container">
              <div className="cnt-label">{t("Your Name")}</div>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="cnt-input"
              />
            </div>
            {/* Email Input */}
            <div className="cnt-container">
              <div className="cnt-label">{t("Your Email")}</div>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="cnt-input"
              />
            </div>
            {/* Category Select */}
            <div className="cnt-container">
              <div className="cnt-label">{t("Category")}</div>
              <select
                className="cnt-input"
                name="category"
                value={formData.category}
                onChange={handleChange}
              >
                <option value="">{t("—Please choose an option—")}</option>
                <option value="Question regarding the mobile identification application">
                  {t(
                    "Question regarding the mobile identification application"
                  )}
                </option>
                <option value="Question regarding the identification on Sundori website">
                  {t(
                    "Question regarding the identification on Sundori website"
                  )}
                </option>
                <option value="Jobs">{t("Jobs")}</option>
                <option value="Partnership or collaboration">
                  {t("Partnership or collaboration")}
                </option>
                <option value="Professional services">
                  {t("Professional services")}
                </option>
                <option value="Technical question">
                  {t("Technical question")}
                </option>
                <option value="Press">{t("Press")}</option>
                <option value="Donation">{t("Donation")}</option>
                <option value="Other">{t("Other")}</option>
              </select>
            </div>
            {/* Subject Input */}
            <div className="cnt-container">
              <div className="cnt-label">{t("Subject")}</div>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                className="cnt-input"
              />
            </div>
            {/* Message Textarea */}
            <div className="cnt-container">
              <div className="cnt-label">{t("Your Message")}</div>
              <textarea
                value={formData.message}
                name="message"
                onChange={handleChange}
                className="cnt-input cnt-message"
              />
            </div>
            {/* Submit Button */}
            <button onClick={handleSubmit} className="cnt-btn">
              {t("Submit")}
            </button>
            {/* Success and Error Messages */}
            {successMessage && (
              <div className="cnt-success">{successMessage}</div>
            )}
            {errorMessage && <div className="cnt-error">{errorMessage}</div>}
          </div>
          <div className="cnt-right">
            <div className="cnt-project">
              {t(
                "Wanna start a new project or microproject with L A Technologies? A partnership? Or simply, a question? Don't hesitate and write to us!"
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Exporting the Contact component as default export
export default Contact;
